// extracted by css-extract-rspack-plugin
export default {"timestamp":"ForYouIssueComment-module__timestamp__za8BX"};